import Register from "../../components/register/Register.vue"

export default {
    components: { Register },

    data: () => ({
        customItemsRegister: {},
        loading: false
    }),

    created(){
        window.scrollTo(0,0);
        this.loading = !this.loading
        this.customItemsRegister = this.DATACUSTOM.text
        this.loading = !this.loading
    }
}